// ProfileCardItem.js
'use strict';
import { connect } from 'react-redux';

import {
  POST_RATING_COLOR_THRESHOLDS,
  LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE,
} from '../RemoteConfigKeys.js';

import ProfileCardItem from '../component/ProfileCardItem.jsx';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getMessageData from '../selector/getMessageData.js';
import getUploadJobStatusI18nKey from '../selector/getUploadJobStatusI18nKey.js';
import getUploadJobFailedReasonI18nKey from '../selector/getUploadJobFailedReasonI18nKey.js';
import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getAssetData from '../selector/getAssetData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';

import { getKeySystem } from '../resource/getDrmInfo.js';

const mapStateToProps = (state, { messageId, categoryId: category }) => {
  const meUsername = getMeData(state, 'username');
  const uploadJobId = getMessageData(state, messageId, 'uploadJobId');
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const assetId = assetIds?.[0];
  const ratingColorThresholds = getRemoteConfigData(
    state,
    POST_RATING_COLOR_THRESHOLDS
  );
  const ratingStepSize = getRemoteConfigData(
    state,
    LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE
  );

  const isFree = getMessageData(state, messageId, 'unlockPrice') === 0;
  const viewScope = getMessageData(state, messageId, 'viewScope');

  return {
    feedId: getOperationData(state, ['fetchedRenewFeedId', category], 'id'),
    clipSourceId: getMessageData(state, messageId, 'clipSourceId'),
    originalCaptionText: getMessageDataWithVariable(
      state,
      messageId,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    uploadJobStatus: getOperationData(
      state,
      ['uploadJob', uploadJobId],
      'status'
    ),
    statusI18nKey: getUploadJobStatusI18nKey(state, uploadJobId),
    reasonI18nKey: getUploadJobFailedReasonI18nKey(state, uploadJobId),
    clipStartMsec: getMessageData(state, messageId, 'clipStartMsec'),
    mediaType: assetId
      ? getAssetData(state, [assetId], 'contentType')
      : getMessageData(state, messageId, 'mediaType'),
    expiresAtUnix: getMessageData(state, messageId, 'expiresAtUnix'),
    ratingColorThresholds,
    ratingStepSize,
    isUnlocked: !isFree && viewScope === 'sd',
    isFree,
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    isDrmLicenseAvailabilityFetched: getNetworkingData(
      state,
      ['drm', 'licenseAvailability', messageId],
      'isFetched'
    ),
  };
};
const mapDispatchToProps = (dispatch, { messageId }) => ({
  fetchDrmLicenseAvailability: () => {
    return dispatch(
      fetchDrmLicenseAvailability({ messageId, keySystem: getKeySystem() })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileCardItem);
